<template>
  <div>
    <el-form ref="form" :model="form" label-width="80px" class="workform">
      <el-form-item label="任务类型" class="formrequired">
        <el-radio-group
          v-model="form.worktype"
          class="selectbtnlist"
          @change="worktypetab(form.worktype)"
        >
          <el-radio-button label="1">课前预习</el-radio-button>
          <el-radio-button label="2">课后复习</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="作业名称" class="formrequired workname">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="作业描述" class="formrequired">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="form.textarea"
        >
        </el-input>
      </el-form-item>
      <el-form-item
        label="上传作业"
        class="formrequired selectbtnlist clearfix"
      >
        <div class="inputupload">
          选择文件
          <input
            type="file"
            class="face"
            :accept="uploadtype"
            @change="upload_photo"
            ref="inputer"
          />
        </div>
      </el-form-item>
      <div id="showPic" class="imglistbox clearfix"></div>
      <el-form-item
        label="发布班级 "
        class="formrequired selectbtnlist selectbtnlist2 clearfix"
      >
        <div
          v-for="(item, index) in this.actionb"
          :key="index"
          class="radioclasslist"
          @click="radioclass(item, index)"
          :class="{ subjactive: iteminx == index }"
        >
          {{ item.name }}
        </div>
      </el-form-item>
    </el-form>

    <el-button
      type="primary"
      class="submitbtn"
      @click="issuework"
      v-loading.fullscreen.lock="fullscreenLoading"
      >确认发布</el-button
    >

    <!-- 选择学生弹窗 -->
    <div class="studentlist" v-show="this.studentlistbox == true">
      <div class="studentdata clearfix">
        <div class="studentdatatitle">一年级一班学习名单</div>
        <div class="oparationbox clearfix">
          <el-button @click="clearcheck">清空</el-button>
          <el-button type="primary" @click="allcheck">全选</el-button>
        </div>
        <!-- //添加学生 -->
        <div class="classlist fl">
          <div
            v-for="data in this.studentlist"
            :key="data.id"
            @click="checkstudent(data)"
          >
            <div class="studentico">
              <img :src="studetico" alt="" width="100%" />
            </div>
            <div>{{ data.user_nicename }}</div>
            <!-- user_id -->
          </div>
        </div>
        <!-- 右侧学生 -->
        <div class="checkstudentlist fl">
          <div
            v-for="(res, index) in this.checklist"
            :key="index"
            @click="clearstudent(res)"
          >
            <div class="studentico">
              <img :src="studetico" alt="" width="100%" />
            </div>
            <div>{{ res.user_nicename }}</div>
          </div>
        </div>
        <div class="checkstudentlength clearfix">
          <p>
            已选学生名单 <span>{{ this.checklist.length }}</span
            >人
          </p>
          <el-button type="primary" @click="savestudentval">保存</el-button>
          <el-button type="info" @click="cancelstudent">取消</el-button>
        </div>
      </div>
    </div>
    <!-- //选择以往试卷 -->
    <el-dialog
      class="userexambody"
      title="选择历史试卷"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      @close="removeste"
    >
      <div class="historyexam">
        <div
          v-for="data in historyexam"
          :key="data.exam_id"
          @click="checkexam(data)"
        >
          {{ data.title }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "../../assets/work.css";
import eventBus from "@/api/eventBus";
import URL from "@/api/index";
import $ from "jquery";
import axios from "axios";
export default {
  data() {
    return {
      uploadtype: ".doc,.docx,image/png,.jpg,.jpeg,.gif,bmp,.pdf,.ppt,.pptx",
      studentlistbox: false,
      form: {
        name: "",
        worktype: "1",
        classval: "",
        subjectval: "",
        textarea: "",
        workid: "",
        studentid: [],
        starttimeval: "",
        endtimeval: "",
        grade_id: "",
        grade_name: "",
        class_name: "",
      },
      studetico: require("../../assets/user.png"),
      studentlist: [],
      checklist: [],
      fileList: [],
      actionb: [],
      checkboxGroup1: "",
      iteminx: -1,
      dialogFormVisible: false,
      historyexam: [],
      workid: "",
      studentste: false,
      studenlist: "选择学生",
      uploadimglist: [],
      contentimg: [],
      fullscreenLoading: false,
    };
  },
  mounted() {
    this.Token = JSON.parse(localStorage.getItem("loginInfo")).token;
    this.form.name = this.$route.query.worktitle;
    this.form.workid = this.$route.query.examid;
    // console.log(this.form)
    this.getclasslist();
    this.getuserexam();
    this.getstudentlist();
    var that = this;
    this.$nextTick(function () {
      //图片上传删除
      $(".imglistbox").on("click", ".delimg", function () {
        var clickind = $(this).parent().parent().index();
        $(".imglistbox>div").eq(clickind).remove();
        that.uploadimglist.splice(clickind, 1);
        // console.log(that.uploadimglist,'删除数据')
      });
    });
    this.getOssToken();
  },
  methods: {
    //上传文件
    upload() {
      this.fullscreenLoading = true;
      var _self = this;
      var file = this.uploadimglist;
      var i = 0;
      var fileleng = file.length;
      // console.log(file.length);
      if (fileleng == 0) {
        this.$message({
          message: "请选择文件",
          type: "warning",
        });
        return;
      }
      // console.log(11111111);
      var contentimg = new Array(); //多图片数组
      for (i; i < fileleng; i++) {
        var onefile = file[i];
        var filename = onefile.name;
        var uploadname = onefile.name;
        var getSuffix = function (filename) {
          var pos = filename.lastIndexOf(".");
          var suffix = "";
          if (pos != -1) {
            suffix = filename.substring(pos);
          }
          return suffix;
        };
        // var filenamelist = file.name
        filename =
          filename.split(".")[0] + new Date().getTime() + getSuffix(filename);
        var formData = new FormData();
        //注意formData里append添加的键的大小写
        formData.append(
          "key",
          _self.aliyunOssToken.dir + "conformity/teacher/" + filename
        ); //存储在oss的文件路径
        formData.append("OSSAccessKeyId", _self.aliyunOssToken.accessid); //accessKeyId
        formData.append("policy", _self.aliyunOssToken.policy); //policy
        formData.append("Signature", _self.aliyunOssToken.signature); //签名
        //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
        formData.append("callback", _self.aliyunOssToken.callback); //policy
        formData.append("file", onefile);
        formData.append("success_action_status", 200); //成功后返回的操作码
        var url = _self.aliyunOssToken.host;
        var fileUrl =
          _self.aliyunOssToken.host + "/" + _self.aliyunOssToken.dir + filename;
        var point = this;
        $.ajax({
          url: url,
          type: "POST",
          data: formData,
          async: false,
          cache: false,
          contentType: false,
          processData: false,
          success: function (data) {
            point.imgurl = data.filename;
            var dataimg = data.filename; //上传图片链接
            contentimg.push(
              //把链接存入数组
              {
                name: uploadname,
                url: dataimg,
              }
            );
          },
          error: function (data) {},
        });
        this.contentimg = contentimg;
        // console.log(this.contentimg,"图片列表")
      }
    },
    //0ss令牌
    getOssToken() {
      var _self = this;
      this.$get(URL.osstoken).then(function (res) {
        _self.aliyunOssToken = res;
      });
    },
    //获取上传文件地址
    upload_photo: function () {
      var that = this;
      var inputDOM = that.$refs.inputer;
      var file = inputDOM.files;
      // console.log(file[0])
      this.uploadimglist.push(file[0]); //选择图片保存为数组
      for (var i = 0; i < file.length; i++) {
        var fr = new FileReader();
        var index = file[0].name.lastIndexOf(".");
        var nameof = file[0].name.substring(index + 1, file[0].length);
        // console.log(nameof)
        //针对文件后缀判断类型
        var filetype;
        if (nameof == "doc" || nameof == "docx") {
          filetype = "word";
        } else if (nameof == "xlsx" || nameof == "xls") {
          filetype = "xcel";
        } else if (nameof == "txt") {
          filetype = "txt";
        } else if (nameof == "pdf") {
          filetype = "pdf";
        } else if (
          nameof == "mp3" ||
          nameof == "wma" ||
          nameof == "wmv" ||
          nameof == "acc" ||
          nameof == "m4a"
        ) {
          filetype = "audio";
        } else if (nameof == "ppt" || nameof == "pptx") {
          filetype = "ppt";
        } else if (
          nameof == "png" ||
          nameof == "jpg" ||
          nameof == "jpeg" ||
          nameof == "webp" ||
          nameof == "gif" ||
          nameof == "PNG " ||
          nameof == "JPG" ||
          nameof == "JPEG" ||
          nameof == "webp" ||
          nameof == "GIF"
        ) {
          filetype = "";
        } else if (
          nameof == "mp4" ||
          nameof == "avi" ||
          nameof == "mov" ||
          nameof == "ram"
        ) {
          filetype = "video";
        } else {
          filetype = "other";
        }
        fr.readAsDataURL(file[i]);
        fr.onload = function (ev) {
          var img = `<div>
                        <div class="work${filetype}">
                            <img src="${this.result}" alt="" >
                            <span class="delimg" >×</span>
                        </div>
                        <div class="imgname">${file[0].name}</div>
                    </div>
                    `;
          $("#showPic").append(img);
        };
      }
    },
    //发布作业
    issuework() {
      //1为预习 2复习
      // console.log(111);
      var filedata = {
        type: this.form.worktype,
        content: this.form.textarea,
        class_id: this.form.classval,
        subject_id: this.form.subjectval,
        token: this.Token,
        title: this.form.name,
        attachment: JSON.stringify(this.contentimg),
      };
      // console.log(filedata);
      if (this.form.name == undefined) {
        this.$message("请填写作业名称");
        this.fullscreenLoading = false;
        return;
      }
      if (this.form.textarea == "") {
        this.$message("请填写作业描述");
        this.fullscreenLoading = false;
        return;
      }
      if (this.form.classval == "") {
        this.$message("请选择班级");
        this.fullscreenLoading = false;
        return;
      }
      if (this.uploadimglist.length == 0) {
        this.$message({
          message: "请选择文件",
          type: "warning",
        });
        return;
      }
      this.upload();
      this.fullscreenLoading = false;
      //   数据上报
      if (this.form.worktype == 1) {
        //   预习
        this.getRecordRjw(JSON.parse(localStorage.getItem("loginInfo")));
      } else {
        //   复习
        this.getRecordRreview(JSON.parse(localStorage.getItem("loginInfo")));
      }

        this.$post(URL.assignTask, filedata).then((res) => {
          this.fullscreenLoading = false;
          if (res.msg == "成功") {
            this.$message("发布" + res.msg);
            this.$router.push({
              name: "taskwork",
            });
          }
        });
      this.fullscreenLoading = false;
    },
    removeimg: function () {
      // console.log("222")
    },
    // 预习数据上报
    getRecordRjw(hh) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "teapreview_send",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "发布了课前预习任务",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("task_traceid")),
            job_name: this.form.name,
            job_describe: this.form.textarea,
            address: JSON.stringify(this.contentimg),
            grade_id: this.form.grade_id,
            grade_name: this.form.grade_name,
            class_id: this.form.classval,
            class_name: this.form.class_name,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    // 复习数据上报
    getRecordRreview(hh) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "teareview_send",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "发布了课后复习任务",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("task_traceid")),
            job_name: this.form.name,
            job_describe: this.form.textarea,
            address: JSON.stringify(this.contentimg),
            grade_id: this.form.grade_id,
            grade_name: this.form.grade_name,
            class_id: this.form.classval,
            class_name: this.form.class_name,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    //获取班级学生
    getstudentlist() {
      var classdata = {
        token: this.Token,
        class_id: this.form.classval,
      };
      this.$post(URL.getstudentlist, classdata).then((item) => {
        this.studentlist = item.result;
        //选择学生的时候学生列表和学生id初始化
        this.checklist = [];
        this.form.studentid = [];
      });
    },
    //选择历史试卷
    checkexam(val) {
      this.form.workid = val.exam_id;
      this.form.name = val.title;
      this.dialogFormVisible = false;
    },
    //获取历史试卷
    getuserexam() {
      var userexamdata = {
        token: this.Token,
      };
      this.$post(URL.GetUserExam, userexamdata).then((res) => {
        this.historyexam = res.result.rows;
      });
    },
    //点击班级
    radioclass(val, index) {
      this.form.classval = val.class_id;
      this.form.subjectval = val.subject_id;
      this.form.grade_id = val.grade_id;
      this.form.grade_name = val.grade_name;
      this.form.class_name = val.class_name;
      this.iteminx = index;
      //暂不显示选择学生
      this.studentste = true;
      this.getstudentlist();
    },
    //获取教师班级
    getclasslist() {
      this.$post(URL.getMasterClass, {
        token: this.Token,
      }).then((getclasslist) => {
        // console.log(getclasslist);
        var classnamelist = getclasslist.result;
        var i = 0;
        if (classnamelist == "") {
          this.actionb.push({
            name: "暂无班级",
          });
        } else {
          for (i; i < classnamelist.length; i++) {
            // console.log(classnamelist[i].subject_name)
            var name = classnamelist[i].class_name; //班级
            // var school = classnamelist[i].school_name
            var grade_name = classnamelist[i].grade_name;
            var classname = grade_name + name;
            var classid = classnamelist[i].class_id;
            var subject = classnamelist[i].subject_name;
            var subnameid = classnamelist[i].subject_id;
            this.actionb.push({
              name: classname,
              class_id: classid,
              subject_id: subnameid,
              grade_id: classnamelist[i].grade_id,
              grade_name: classnamelist[i].grade_name,
              class_name: classnamelist[i].class_name,
            });
            this.unique(this.actionb);
          }
        }
      });
    },
    //去重
    unique(arr) {
      for (var i = 0, len = arr.length; i < len; i++) {
        for (var j = i + 1, len = arr.length; j < len; j++) {
          // console.log(arr[i],arr[j])
          if (arr[i].class_id === arr[j].class_id) {
            arr.splice(j, 1);
            // console.log("2")
            j--;
            len--;
          }
        }
      }
      return arr;
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreview(file) {
      // console.log(file);
    },
    //题库作业或错题集作业
    wordtype(val) {
      if (val == 1) {
        this.$router.push({
          name: "wordlist",
        });
      } else if (val == 3) {
        this.dialogFormVisible = true;
      }
      // console.log(val)
    },
    //关闭选择状态取消
    removeste() {
      this.form.workval = "";
    },
    //作业类型
    worktypetab(val) {
      // console.log(val)
    },
    //开始时间 结束时间
    endtime() {
      // console.log(this.form.endtimeval)
    },
    starttime() {
      // console.log(this.form.starttimeval)
    },
    //选择学生弹窗
    studentlistpopup() {
      this.studentlistbox = true;
    },
    // 选择学生
    checkstudent(val) {
      // console.log(val)
      this.checklist.push({
        user_nicename: val.user_nicename,
        user_id: val.user_id,
      });
      this.studentlist.forEach((item, index) => {
        if (item.user_id == val.user_id) {
          this.studentlist.splice(index, 1);
        }
      });
      // console.log(this.checklist,this.studentlist)
    },
    //取消单个学生
    clearstudent(val) {
      // console.log(val)
      this.studentlist.push({
        user_nicename: val.user_nicename,
        user_id: val.user_id,
      });
      this.checklist.forEach((item, index) => {
        if (item.user_id == val.user_id) {
          this.checklist.splice(index, 1);
        }
      });
    },
    //选择全部学生
    allcheck() {
      this.studentlist.forEach((item, index) => {
        this.checklist.push({
          user_nicename: item.user_nicename,
          user_id: item.user_id,
        });
        this.studentlist = [];
      });
    },
    //清空学生
    clearcheck() {
      this.checklist.forEach((item, index) => {
        this.studentlist.push({
          user_nicename: item.user_nicename,
          user_id: item.user_id,
        });
        this.checklist = [];
      });
    },
    //取消选择弹窗
    cancelstudent() {
      this.studentlistbox = false;
      this.clearcheck();
    },
    //确定选择弹窗
    savestudentval() {
      this.studentlistbox = false;
      localStorage.setItem("studentlist", JSON.stringify(this.checklist));
      // console.log(this.checklist)
      this.checklist.forEach((val) => {
        // console.log(val.user_id)
        this.form.studentid.push(val.user_id);
      });
      this.studenlist = "学生" + this.form.studentid.length + "人";
    },
  },
};
</script>